const types = {
    SET_LOADING: '[ADMIN] LOADING'
}

export {
    types
}